import {
  Card,
  CardHeader,
  FormControl,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Typography
} from '@mui/material';
import {
  DataGrid, gridPageCountSelector,
  gridPageSelector,
  koKR,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { apiService } from '../../api/axiosClient';
import Spinner from '../../components/spinner';
import CustomNoRowsOverlay from '../../utils/CustomNoRowsOverlay';
import LeadToolbar from './LeadToolbar';

const TableLead = props => {
  const { filters, submit, page, setPage, pageSize, setPageSize } = props;

  const [loading, setLoading] = useState(true)
  const [reload, setReload] = useState(0)
  const [total, setTotal] = useState(0)
  const [sortColumn, setSortColumn] = useState('mb_update')
  const [sort, setSort] = useState('desc')
  const [list, setList] = useState([])  
  const [selected, setSelected] = useState([]);

  const loadColumnMemberTable = window.localStorage.getItem('columnLeadTable') ? 
      JSON.parse(window.localStorage.getItem('columnLeadTable')) : 
      {
        subscribe_date: true,
      };
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(loadColumnMemberTable);

  const loadLead = 
    async (sort, column) => {
      try {
        const response = await apiService.get('/lead', {
          params: {
            ...filters,
            sort,
            column,
            page,
            pageSize
          }
        });
        setTotal(response.data.size);
        setList(response.data.list);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    }

  useEffect(() => {
      const {startDate, endDate} = filters;

      if(!isEmpty(startDate) && !isEmpty(endDate)) {
        loadLead(sort, sortColumn)
      }
  }, [page, pageSize, reload, submit, filters])

  useEffect(() => {
      window.localStorage.setItem('columnLeadTable', JSON.stringify(columnVisibilityModel) );
      setColumnVisibilityModel(columnVisibilityModel);
  }, [columnVisibilityModel])

  const handleSortModel = (newModel) => {
    if (newModel.length) {
      setSort(newModel[0].sort)
      setSortColumn(newModel[0].field)
      loadLead(newModel[0].sort, newModel[0].field)
    } else {
      setSort('desc')
      setSortColumn('mb_update')
    }
  }

  const onPageSizeChange = e => {
    setPageSize(e.target.value)
  }

  function CustomPagination() {
    const apiRef = useGridApiContext();
    const _page = useGridSelector(apiRef, gridPageSelector);
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);

    return (
      <Stack direction="row" spacing={2} sx={{ pr: 4, alignItems: 'center' }}>
        <InputLabel id="pagesize-select">행/페이지</InputLabel>
        <FormControl variant="standard" sx={{ mr: 1, minWidth: 70 }}>
          <Select
            labelId="pagesize-select"
            id="pagesize-select"
            value={pageSize}
            onChange={onPageSizeChange}
            label="pageSize"
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          color="primary"
          count={pageCount}
          page={_page + 1}
          onChange={(event, value) => apiRef.current.setPage(value - 1)}
        />
      </Stack>
    );
  }

  const columns = [
    {
      minWidth: 200,
      field: 'mb_update',
      headerName: '등록날짜',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {moment(params.row.mb_update).format("YYYY-MM-DD")}
        </Typography>
      )
    },
    {
      minWidth: 120,
      field: 'mb_charge',
      headerName: '영업담당자',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_charge}
        </Typography>
      )
    },
    {
      minWidth: 150,
      field: 'mb_field',
      headerName: '관심',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_field}
        </Typography>
      )
    },
    {
      minWidth: 200,
      field: 'mb_type',
      headerName: '업체분류',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_type}
        </Typography>
      )
    },
    {
      minWidth: 200,
      field: 'mb_company',
      headerName: '업체명',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_company}
        </Typography>
      )
    },
    {
      minWidth: 200,
      field: 'mb_name',
      headerName: '담당자명',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_name}
        </Typography>
      )
    },
    {
      minWidth: 200,
      field: 'mb_position',
      headerName: '직함/교수',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_position}
        </Typography>
      )
    },
    {
      minWidth: 200,
      field: 'mb_hp',
      headerName: '휴대폰',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_hp}
        </Typography>
      )
    },
    {
      minWidth: 200,
      field: 'mb_tel',
      headerName: '유선번호',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_tel}
        </Typography>
      )
    },
    {
      minWidth: 200,
      field: 'mb_email',
      headerName: '이메일',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_email}
        </Typography>
      )
    },
    {
      minWidth: 400,
      field: 'mb_note',
      headerName: '메모',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_note}
        </Typography>
      )
    },
    {
      minWidth: 100,
      field: 'mb_src',
      headerName: '리드소스',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_src}
        </Typography>
      )
    },
    {
      minWidth: 100,
      field: 'mb_status',
      headerName: '리드상태',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_status}
        </Typography>
      )
    },
    {
      minWidth: 200,
      field: 'mb_addr',
      headerName: '주소',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_addr}
        </Typography>
      )
    },
    {
      minWidth: 100,
      field: 'mb_important',
      headerName: '중요도',
      renderCell: params => (
        <Typography variant='body2' sx={{ color: 'text.primary' }}>
          {params.row.mb_important}
        </Typography>
      )
    }
  ]

  return (
    loading ?
    <Spinner/>
    :
    <Card>
      <CardHeader title='리드내역' />
      <DataGrid
        sx={{
          ...((list?.length || 0) == 0 && { '& .MuiDataGrid-virtualScrollerContent': {height: '200px !important' } })
        }}
        localeText={koKR.components.MuiDataGrid.defaultProps.localeText}
        autoHeight
        getRowId={row => row.mb_id}
        pagination
        rows={list || []}
        rowCount={total || 0}
        columns={columns}
        pageSize={pageSize}
        sortingMode='server'
        paginationMode='server'
        onSortModelChange={handleSortModel}
        onPageChange={newPage => setPage(newPage)}
        components={{
          Toolbar: LeadToolbar,
          Pagination: CustomPagination,
          NoRowsOverlay: CustomNoRowsOverlay,
        }}
        componentsProps={{
          toolbar: {
            numSelected: selected?.length || 0,
            selected,
            setReload
          }
        }}
        checkboxSelection
        disableSelectionOnClick
        onSelectionModelChange={(ids) => {
          const selectedIDs = new Set(ids);
          const selectedRows = (list || []).filter((row) =>
            selectedIDs.has(row.mb_id),
          );

          setSelected(selectedRows)
        }}
        experimentalFeatures={{ newEditingApi: true }}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={(newModel) =>
          setColumnVisibilityModel(newModel)
        }
      />
    </Card>
  )
}

export default TableLead
